{
    "PreviewHeader": "Pré-visualizar",
    "PreviewValueInvalid": "[Formato Inválido]",
    "NAME": "Preview"
}